import React, {useState, useEffect, useCallback} from "react";

import axios from "axios";
import { getRestIdFromGid } from "@utility/shopify"
import { gql } from "graphql-request";
import { useShopQuery } from "@hooks/use-shop-query.js";

const queryCartNotes = gql`
query CartNotes($country:CountryCode!) @inContext(country: $country){
  cartNotes: metaobjects(first:100, type:"cart_note"){
			edges{
				node{
					name: field(key:"name"){
						value
					}
					content: field(key:"content"){
						value
					}
					rules: field(key:"rules"){
						value
					}
					priority: field(key:"priority"){
						value
					}
          active: field(key:"active"){
						value
					}
          level: field(key:"level"){
						value
					}
    		}
		  }
  }
}`

export const CartContext = React.createContext({
  loading: true
});

export const CartProvider = ({children}) => {

  const variables = { country: Shopify.country }
  const {data:notesData, loading:notesLoading, error} = useShopQuery(queryCartNotes, variables);

  var [cart, setCart] = useState()
  var [loading, setLoading] = useState(true);

  useEffect(()=>{
    getCart();
    window.addEventListener('variant:add', getCart);

    // cleanup this component
    return () => {
      window.removeEventListener('variant:add', getCart);
    };
  }, []);

  const getCart = useCallback(async () => {
    setLoading(true);
    const response = await axios.get('/cart.json');
    setCart(response.data);
    setLoading(false);
  }, []);

  const addToCart = async (variant) => {
    setLoading(true);
    let formData = {
     'items': [{
      'id': getRestIdFromGid(variant.id),
      'quantity': 1
      }]
    };
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    await getCart();
  }

  const updateCart = async (lineKey, targetQuantity) => {
    setLoading(true);
    let formData = {
      id: lineKey,
      quantity: targetQuantity,
    };
    const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    await getCart();
  }

  return <CartContext.Provider value={{ loading, cart, getCart, addToCart, updateCart, cartNotes: notesData?.cartNotes }}>
    {children}
    </CartContext.Provider>;
}
